<template>
    <div class="artifact pb-4">
        <div class="title-body ps-3 py-2">
            Danh sách hiện vật
        </div>
        <div class="mt-3">
            <div class="table-category height-body position-relative pb-4">
                <div class="row justify-content-center">
                    <div class="col-6">
                        <div class="search-input input-group mb-3">
                            <input type="text" class="form-control" v-model="keyword" placeholder="Tìm kiếm hiện vật">
                            <span class="input-group-text"><i class="icon ion-md-search"></i></span>
                        </div>
                        <table class="table table-bordered mb-2">
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Ảnh đại diện</th>
                                    <th scope="col">Tên hiện vật</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody v-if="artifact.data">
                                <tr v-for="(item, index) in artifact.data" :key="index">
                                    <td width="50" class="text-center">{{ item.id }}</td>
                                    <td width="100">
                                        <img class="img-preview" :src="`${url}/images/${item.thumb_img}`" :alt="item.thumb_img" v-if="item.thumb_img"/>
                                        <img class="img-preview" :src="`${url}/image/no-image.png`" :alt="item.thumb_img" v-else/>
                                    </td>
                                    <td><p class="title-artifact" v-html="item.title"></p></td>
                                    <td width="250">
                                        <div class="d-flex justify-content-center">
                                            <div class="edit me-2">
                                                <button class="btn btn-copy text-white" @click="copyArtifact(item.id)" data-bs-toggle="tooltip" data-bs-placement="top" title="Copy đường dẫn hiện vật">
                                                    <i class="icon ion-md-copy"></i>
                                                </button>
                                            </div>
                                            <div class="edit mx-2">
                                                <button class="btn btn-primary" @click="showDetail(item.id)" data-bs-toggle="tooltip" data-bs-placement="top" title="Xem chi tiết hiện vật">
                                                    <i class="icon ion-md-eye"></i>
                                                </button>
                                            </div>
                                            <div class="edit mx-2">
                                                <button class="btn btn-success" @click="showArtifact(item.id)" data-bs-toggle="tooltip" data-bs-placement="top" title="Chỉnh sửa hiện vật">
                                                    <i class="icon ion-md-create"></i>
                                                </button>
                                            </div>
                                            <div class="delete ms-2">
                                                <button class="btn btn-danger" data-bs-toggle="modal" :data-bs-target="`#delArtifact-${index}`">
                                                    <i class="icon ion-md-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="modal fade modal-custom modal-del" :id="`delArtifact-${index}`" tabindex="-1" aria-hidden="true">
                                            <div class="modal-dialog">
                                                <div class="modal-content">
                                                    <div class="modal-header p-2 bg-danger">
                                                        <div class="modal-title text-white">Xoá hiện vật</div>
                                                        <button type="button" class="btn text-white" data-bs-dismiss="modal"><i class="icon ion-md-close"></i></button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <div class="row justify-content-center py-4">
                                                            <div class="col-8">
                                                                <div class="fw-bold">
                                                                    Bạn chắc chắn muốn xoá hiện vật này?
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mt-3 text-center">
                                                            <button type="button" class="btn btn-danger me-2" @click="delArtifact(item.id)">Xoá hiện vật</button>
                                                            <button type="button" class="btn btn-secondary ms-2 px-4" data-bs-dismiss="modal">Huỷ</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="3" class="no-artifact py-4">Không có hiện vật nào cả</td>
                                </tr>
                            </tbody>
                        </table>
                            <div v-if="keyword == ''">
                                <pagination :data="artifact" @pagination-change-page="getArtifact" :limit=2 align="right"></pagination>
                            </div>
                            <div v-else>
                                <pagination :data="artifact" @pagination-change-page="search" :limit=2 align="right"></pagination>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pagination from 'laravel-vue-pagination';
export default {
    components:{
        pagination
    },
    data() {
        return {
            artifact: {
                type:Object,
                default:null,
            },
            url: process.env.VUE_APP_API_URL,
            keyword: '',
        }
    },

    watch: {
        keyword(val) {
            if( val.length > 1 ) {
                this.search();
            }

            if(val == '') {
                this.getArtifact();
            }
        }
    },

    created() {
        this.getArtifact();
    },
    methods: {
        getArtifact(page=1) {
            apiGet('/artifact?page=' + page).then(res => {
                this.artifact = res;
            }).catch(err => {
                console.log(err);
            })
        },

        showArtifact(id) {
            this.$router.push({
                name: 'artifact-edit',
                params: {
                    id: id,
                }
            })
        },

        delArtifact(id) {
            apiDelete(`/artifact/delete/${id}`).then(res => {
                this.$router.push({
                    name: 'artifact',
                });
            }).catch(err => {
                console.log(err);
            })
        },

        showDetail(id) {
            window.open(`${this.url}/artifact/detail/${id}`, '_blank');
        },

        copyArtifact(id) {
            let domain = location.host
            navigator.clipboard.writeText(`${domain}/artifact/detail/${id}`)
            .then(() => {
                this.$toast.info('Đã copy đường dẫn hiện vật', {
                    timeout: 3000,
                });
            })
            .catch(err => {
                console.log(err);
            });
        },

        search(page=1) {
            apiGet('/artifact/search/' + this.keyword + '/?page=' + page).then(res => {
                this.artifact = res;
            }).catch(err => {
                console.log(err);
            })
        }
    }
}
</script>

<style lang="scss">
.artifact {
    .table-category {
        .table>:not(:first-child) {
            border-top: none !important;
        }
        td {
            vertical-align: middle;
        }
    }
    .modal-custom {
        .modal-dialog {
            margin-top: 15%;
            .modal-content {
                border: none;
                .modal-header {
                    font-size: 18px;
                    font-weight: 600;
                    border: none;
                }
            }
        }
    }
    .no-artifact {
        text-align: center;
        font-size: 20px;
        color: #666;
    }
    .btn-copy {
        background: #9b59b6;
    }
    .title-artifact {
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        overflow: hidden;
    }
    .img-preview {
        width: 100px;
    }
    .search-input {
        font-size: 20px;
        vertical-align: -2px;
        input {
            border-right: 0 !important;
            &:focus {
                border-color: #ced4da !important;
            }
        }
        .input-group-text {
            background: transparent;
            border-left: 0 !important;
            i {
                &::before {
                    font-size: 22px;
                    vertical-align: -2px;
                }
            }
        }
    }
}
</style>
